import { SET_MESSAGE_AUTOMATIONS } from '../actions/types';

export default function messageAutomationReducer(state = [], action) {
	switch (action.type) {
		case SET_MESSAGE_AUTOMATIONS:
			return action.payload || state;
		default:
			return state;
	}
}
